import { gql } from '@apollo/client';

export const DOCUMENT_TEMPLATE_UPDATED = gql`
  subscription documentTemplateUpdated {
    documentTemplateUpdated {
      documentTemplateId
    }
  }
`;

export const DOCUMENT_TEMPLATE_FILE_UPLOADED = gql`
  subscription documentTemplateFileUploaded {
    documentTemplateFileUploaded {
      documentTemplateId
      documentTemplateName
    }
  }
`;

export const DOCUMENT_TEMPLATE_FILTER_UPDATED = gql`
  subscription documentTemplateFilterUpdated {
    documentTemplateFilterUpdated {
      documentTemplateId
    }
  }
`;

export const DOCUMENT_TEMPLATE_USER_GROUPS_UPDATED = gql`
  subscription documentTemplateXUserGroupsSaved {
    documentTemplateXUserGroupsSaved {
      documentTemplateXUserGroups {
        documentTemplateId
        userGroupId
      }
    }
  }
`;

export const DOCUMENT_TEMPLATE_SIGNATURES_UPDATED = gql`
  subscription documentTemplateXSignaturesSaved {
    documentTemplateXSignaturesSaved {
      documentTemplateXSignatures {
        documentTemplateId
        signatureId
        implicit
      }
    }
  }
`;

export const SIGNATURE_BOOKMARKS_UPDATED = gql`
  subscription signatureBookmarksUpdated {
    signatureBookmarksUpdated {
      signatureBookmarks {
        id
        isTable
        name
        signatureBookmarkActors {
          id
          signatureBookmarkId
          actorId
        }
        templateId
      }
    }
  }
`;

export const DOCUMENT_TEMPLATE_X_OPTION_BOOKMARKS_UPDATED = gql`
  subscription documentTemplateXOptionBookmarksUpdated {
    documentTemplateXOptionBookmarksUpdated {
      documentTemplateXOptionBookmarks {
        id
        bookmarkName
        dataSource
        templateId
      }
    }
  }
`;
